// extracted by mini-css-extract-plugin
module.exports = {"heading":"AnimatedHeading--heading--1CbPK"};